import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const EmojiDialog = ({ open, emoji, emojiUrl, account, onClose }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-sm text-center" data-testid="sms-emoji-dialog">
      <DialogHeader>
        <DialogTitle className="font-['Outfit']">Phone pe ye emoji tap karo</DialogTitle>
      </DialogHeader>
      <div className="py-4 flex flex-col items-center gap-3">
        <div className="w-32 h-32 grid place-items-center rounded-2xl bg-[#FAFAF6] border border-[#E0DFD6]" data-testid="sms-emoji">
          {emojiUrl ? <img src={emojiUrl} alt={emoji} className="w-24 h-24" /> : <span className="text-7xl">{emoji}</span>}
        </div>
        <p className="text-sm text-[#3A3A35]">Phone pe Google Messages me popup aayega, usme <b>yahi emoji</b> chuno.</p>
        {account && <p className="text-xs text-[#6B6B61]" data-testid="sms-emoji-account">{account}</p>}
        <p className="text-[11px] text-[#9A9A90]">Popup nahi aaya? Phone pe Google Messages app kholo aur net check karo.</p>
        <button onClick={onClose} className="h-9 px-4 rounded-full border border-[#E0DFD6] text-sm hover:bg-[#EFEEE6] transition-colors" data-testid="sms-emoji-cancel">
          Cancel
        </button>
      </div>
    </DialogContent>
  </Dialog>
);
